const pageNameKey = "taskbarTicketsHistoryPopover";

export const taskbarTicketsHistoryPopoverEn = {
  [pageNameKey]: {
    title: "Recent Chats",
    closeButtonText: "Close",
  },
};

export const taskbarTicketsHistoryPopoverPtBr = {
  [pageNameKey]: {
    title: "Conversas recentes",
    closeButtonText: "Fechar",
  },
};

export const taskbarTicketsHistoryPopoverDe = {
  [pageNameKey]: {
    title: "Letzte Chats",
    closeButtonText: "Schließen",
  },
};

export const taskbarTicketsHistoryPopoverZhHans = {
  [pageNameKey]: {
    title: "最近的聊天",
    closeButtonText: "关闭",
  },
};

export const taskbarTicketsHistoryPopoverIt = {
  [pageNameKey]: {
    title: "Chat recenti",
    closeButtonText: "Chiudi",
  },
};

export const taskbarTicketsHistoryPopoverEs = {
  [pageNameKey]: {
    title: "Chats recientes",
    closeButtonText: "Cerrar",
  },
};

export const taskbarTicketsHistoryPopoverNl = {
  [pageNameKey]: {
    closeButtonText: "Sluiten",
    title: "Recente chats",
  },
};

export const taskbarTicketsHistoryPopoverTr = {
  [pageNameKey]: {
    closeButtonText: "Kapat",
    title: "Son Sohbetler",
  },
};
